import React from "react";
import PdfViewer from "../../PdfViewer";

const PolizaInnesA2026 = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/polizas/010726-Poliza-de-Servicios-Fortigate.pdf`;
  /*const pdfUrl = "/pdf/010726-Poliza-de-Servicios-Fortigate.pdf";*/

  console.log("PDF URL:", pdfUrl);

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Póliza 2026</h1>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default PolizaInnesA2026;
